import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Navbar from "./Navbar";
import React from "react";
import { sections } from "./Navbar/sections";
import HomePage from "../../pages/HomePage";

export default function AppLayout() {
  const [activeSection, setActiveSection] = React.useState("");

  const getAppBarHeight = () =>
    document.getElementById("appbar")?.getBoundingClientRect().height || 64;
  const earlyOffset = window.innerHeight * 0.3;

  React.useEffect(() => {
    const handleScroll = () => {
      const appBarHeight = getAppBarHeight();

      // Find section closest to top but still visible under AppBar
      let current = "";
      for (let s of sections) {
        const el = document.getElementById(s.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top - appBarHeight <= earlyOffset) {
            current = s.id; // update if section top is above appbar bottom
          } else {
            break; // stop once we find a section still below the appbar
          }
        }
      }
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // run on mount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (id) => {
    let isMobile = window.innerWidth < 500;

    if (id === "hero") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const el = document.getElementById(id);

      if (el) {
        const y =
          el.getBoundingClientRect().top + window.scrollY - getAppBarHeight();

        // const top = isMobile ? y - getAppBarHeight() : y;
        const top = y;

        window.scrollTo({ top, behavior: "smooth" });
      }
    }
  };

  return (
    <>
      <Navbar activeSection={activeSection} handleNavClick={handleNavClick} />

      <HomePage />
      {/* <Box sx={{ mt: 13 }}>
        <Outlet />
      </Box> */}
    </>
  );
}
